import React from 'react';
import PropTypes from 'prop-types';

import {frefFromRef} from '../../../lib/react/higher-order-components';
import {OENavigationViewComponent} from '../../../lib/components/oe-navigation-controller';
import OEFlowNavModal from '../flow-nav/oe-flow-nav-modal';
import OEFNHelp from '../flow-nav/help/oe-flow-nav-help';
import {OEHelpViewConfigDecl, OEHelpViewConfigFactory} from './oe-help-view-model';

export class OEHelpViewStd extends React.PureComponent {

    constructor(props) {
        super(props);

        this.ref = null;

        this.state = {};

        this.onRef = this.onRef.bind(this);
    }

    onRef(ref)  {
        if(this.ref !== ref) {
            this.ref = ref;
            this.setState({parent: ref});
        }
        if(this.props.fref) this.props.fref(ref);
    }

    render() {
        return (
            <OEFlowNavModal
                moduleId={this.props.moduleId}
                className={'help-view ' + this.props.className}
                config={{
                    logo: this.props.config.logo,
                    showAtStartUp: this.props.config.showAtStartUp,
                }}
                isOpen={this.props.isOpen}
                onOpenStateChanged={this.props.onOpenStateChanged}
                ref={this.onRef}
            >
                <OENavigationViewComponent title="help_view_title">
                    <OEFNHelp
                        target={this.props.target}
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        locStringPrefix={this.props.config.locStringPrefix}
                        entries={this.props.config.entries}
                        manualViewLinks={this.props.config.manualViewLinks}
                        autoSpacerHeight={this.props.config.autoSpacerHeight}
                        parent={this.state.parent}
                    />
                </OENavigationViewComponent>
            </OEFlowNavModal>
        );
    }
}

OEHelpViewStd.defaultProps = {
    moduleId:           '',
    className:          '',
    config:             OEHelpViewConfigFactory.buildStdConfig()
};

OEHelpViewStd.propTypes = {
    moduleId:           PropTypes.string,
    className:          PropTypes.string,
    config:             OEHelpViewConfigDecl,
    onOpenStateChanged: PropTypes.func
};

export default frefFromRef(OEHelpViewStd);